module.exports = __webpack_public_path__ + "static/img/logo@2x.b8bc108.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/images/logo@2x.png
// module id = YOwG
// module chunks = 27